import produce from 'immer';
import { HEALTH_MONITOR_ACTION } from './actions';

const initialState = {
  settings: [],
  loading: false,
  updating: false,
  type: '',
  error: null,
  // Set when the settings GET failed: the screen must NOT render rows from
  // the empty default (they would show every entity as OFF/既定値 with live
  // toggles, and a toggle built from those defaults destroys server state).
  loadError: null,
};

const HealthMonitorSettings = (state = initialState, action) => {
  const { type: actionType, payload } = action;

  switch (actionType) {
    case HEALTH_MONITOR_ACTION.GET_HEALTH_MONITOR_SETTINGS:
      return produce(state, (draft) => {
        draft.loading = true;
        draft.type = actionType;
        draft.error = null;
        draft.loadError = null;
      });

    case HEALTH_MONITOR_ACTION.UPDATE_HEALTH_MONITOR_SETTING:
      return produce(state, (draft) => {
        draft.updating = true;
        draft.type = actionType;
        draft.error = null;
      });

    case HEALTH_MONITOR_ACTION.GET_HEALTH_MONITOR_SETTINGS_SUCCESS:
      return produce(state, (draft) => {
        draft.settings = payload || [];
        draft.loading = false;
        draft.type = actionType;
        draft.loadError = null;
      });

    // Merge the confirmed PUT payload into the list so toggles persist
    // visually without a full re-fetch. An absent thresholdSeconds in the
    // payload means "clear the override" (the backend REMOVEs the attribute).
    case HEALTH_MONITOR_ACTION.UPDATE_HEALTH_MONITOR_SETTING_SUCCESS:
      return produce(state, (draft) => {
        const index = state.settings.findIndex(
          (x) =>
            x.entityType === payload.entityType &&
            x.entityId === payload.entityId
        );
        const existing = index >= 0 ? state.settings[index] : {};
        const merged = { ...existing, ...payload };
        if (payload.thresholdSeconds === undefined) {
          delete merged.thresholdSeconds;
        }
        if (index >= 0) {
          draft.settings[index] = merged;
        } else {
          draft.settings.push(merged);
        }
        draft.updating = false;
        draft.type = actionType;
      });

    case HEALTH_MONITOR_ACTION.GET_HEALTH_MONITOR_SETTINGS_ERROR:
      return produce(state, (draft) => {
        draft.loading = false;
        draft.type = actionType;
        draft.error = payload;
        draft.loadError = payload || 'error';
      });

    case HEALTH_MONITOR_ACTION.UPDATE_HEALTH_MONITOR_SETTING_ERROR:
      return produce(state, (draft) => {
        draft.updating = false;
        draft.type = actionType;
        draft.error = payload;
      });

    case HEALTH_MONITOR_ACTION.UPDATE_HEALTH_MONITOR_SETTING_CLEAN_STATE:
      return produce(state, (draft) => {
        draft.updating = false;
        draft.type = actionType;
      });

    default:
      return state;
  }
};

export default HealthMonitorSettings;
